const Location = ({ className }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.05051 2.60016C3.36333 1.28734 5.14389 0.549805 7.0005 0.549805C8.85711 0.549805 10.6377 1.28734 11.9505 2.60016C13.2633 3.91298 14.0009 5.69355 14.0009 7.55016C14.0009 9.40677 13.2633 11.1873 11.9505 12.5002L7.0005 17.4502L2.05051 12.5002C1.40042 11.8501 0.884739 11.0784 0.532912 10.2291C0.181084 9.37979 0 8.46947 0 7.55016C0 6.63085 0.181084 5.72054 0.532912 4.87121C0.884739 4.02189 1.40042 3.25018 2.05051 2.60016ZM7.0005 9.55016C7.53094 9.55016 8.03965 9.33945 8.41472 8.96437C8.78979 8.5893 9.00051 8.0806 9.00051 7.55016C9.00051 7.01973 8.78979 6.51102 8.41472 6.13595C8.03965 5.76088 7.53094 5.55016 7.0005 5.55016C6.47007 5.55016 5.96136 5.76088 5.58629 6.13595C5.21122 6.51102 5.0005 7.01973 5.0005 7.55016C5.0005 8.0806 5.21122 8.5893 5.58629 8.96437C5.96136 9.33945 6.47007 9.55016 7.0005 9.55016Z"
        fill="#B0BABF"
      />
    </svg>
  );
};

export default Location;
